import PropTypes from 'prop-types'

import { useStyletron } from 'baseui'
import Icon from 'baseui/icon/icon'

const IconPsychiatry = ({ color, overrides, ref, title, style }) => {
  const [, theme] = useStyletron()

  title = title ?? 'Psychiatry'
  color = color ?? theme.colors.primary

  return (
    <Icon viewBox='0 0 30 31' ref={ref} title={title} overrides={overrides} style={style}>
      <title>{title}</title>
      <path d="M14.1639 27.0476C13.9252 26.8089 13.8058 26.513 13.8058 26.16V17.471C12.477 17.471 11.2001 17.2166 9.97512 16.708C8.75014 16.1993 7.6705 15.4778 6.73619 14.5435C5.80189 13.6092 5.08559 12.5295 4.58729 11.3046C4.08899 10.0796 3.83984 8.8027 3.83984 7.47391V6.22816C3.83984 5.8752 3.95923 5.57934 4.19799 5.34057C4.43676 5.10181 4.73263 4.98242 5.08559 4.98242H6.33133C7.63936 4.98242 8.90586 5.23676 10.1308 5.74544C11.3558 6.25412 12.4355 6.97561 13.3698 7.90992C14.0134 8.55355 14.548 9.25947 14.9737 10.0277C15.3993 10.7959 15.7263 11.616 15.9547 12.488C16.0585 12.3427 16.1727 12.2025 16.2973 12.0676C16.4218 11.9326 16.5568 11.7925 16.7021 11.6471C17.6364 10.7128 18.7161 9.99134 19.9411 9.48267C21.166 8.97399 22.4429 8.71965 23.7717 8.71965H25.0175C25.3704 8.71965 25.6663 8.83903 25.9051 9.0778C26.1438 9.31657 26.2632 9.61243 26.2632 9.96539V11.2111C26.2632 12.5399 26.0089 13.8168 25.5002 15.0418C24.9915 16.2668 24.27 17.3464 23.3357 18.2807C22.4014 19.215 21.3269 19.9313 20.1124 20.4296C18.8978 20.9279 17.6261 21.1771 16.2973 21.1771V26.16C16.2973 26.513 16.1779 26.8089 15.9391 27.0476C15.7003 27.2864 15.4045 27.4058 15.0515 27.4058C14.6986 27.4058 14.4027 27.2864 14.1639 27.0476Z" fill={color}/>
    </Icon>
  )
}

IconPsychiatry.propTypes = {
  color: PropTypes.string,
  overrides: PropTypes.object,
  ref: PropTypes.object,
  title: PropTypes.string,
  style: PropTypes.object,
}

export default IconPsychiatry
